import { api } from "@/lib/api";
import WarehousePackagesList from "./PackagesList";
import { CheckCircle2 } from "lucide-react";
import { useWarehousePermissions } from "@/hooks/useWarehousePermissions";

export default function WarehouseIncoming() {
  const { can } = useWarehousePermissions();
  return (
    <WarehousePackagesList
      status="DROPPED_AT_WAREHOUSE"
      title="Incoming Packages"
      description="Packages dropped off by first-mile riders, awaiting your confirmation."
      action={can("confirm_received") ? {
        label: "Confirm Received",
        testKey: "confirm",
        icon: CheckCircle2,
        className: "bg-cyan-400 text-slate-950 hover:bg-cyan-300",
        successMsg: "Package received.",
        fn: async (pkg) => api.post(`/warehouse/packages/${pkg.package_id}/confirm-received`, {}),
      } : null}
    />
  );
}
